import { HStack, StyleProps, Text } from '@chakra-ui/react';

type PriceProps = {
  price: number;
} & StyleProps;

type PriceWithDiscountProps = {
  price: number;
  discountPercent?: number;
  discountPrice?: number;
} & StyleProps;

const Price = ({ price, ...props }: PriceProps) => (
  <Text
    as='span'
    color='primary.pure'
    fontWeight='bold'
    {...props}
  >
    ${price.toFixed(2)}
  </Text>
);

const PriceWithDiscount = ({
  price,
  discountPercent,
  discountPrice,
  ...props
}: PriceWithDiscountProps) => {
  if (!discountPercent) {
    return (
      <Price
        price={price}
        {...props}
      />
    );
  }
  const discountedPrice = discountPrice || (price * (100 - discountPercent)) / 100;

  return (
    <HStack
      alignItems='center'
      fontSize='2xl'
      spacing={2}
      {...props}
    >
      <Price price={discountedPrice} />
      <Price
        color='text.medium'
        fontWeight='normal'
        price={price}
        textDecoration='line-through'
      />
    </HStack>
  );
};

export default PriceWithDiscount;
